import commonService from './common-service';

class ReplacementService {
  async getDefaults() {
    try {
      const response = await commonService.getFromServer('Replacement/Defaults', {});
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving details. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async postReplacement(params) {
    try {
      const response = await commonService.postToServer('Replacement/Replacement', params);
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving details. Please contact administrator.');
      }
    } catch (e) {
      const error = new Error(e);
      error.code = e.code;
      error.msg = e.msg;
      throw error;
    }
  }
  async postReRuns(params) {
    try {
      const response = await commonService.postToServer('Replacement/ReRun', params);
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving details. Please contact administrator.');
      }
    } catch (e) {
      const error = new Error(e);
      error.code = e.code;
      error.msg = e.msg;
      throw error;
    }
  }
}

export default new ReplacementService();
